import React from "react";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import { Profile } from "./components";

// Profile feature barrel export
export * from './components';
export * from './hooks';
export * from './utils';

/**
 * MyProfilePage - Page wrapper
 * Renders PageLayout + Profile
 */
export const MyProfilePage = () => {
  usePageInitialization();
  return (
    <PageLayout title="My Profile" backPath="/">
      <Profile />
    </PageLayout>
  );
};
